import React from 'react'
import { Row, Col } from 'react-bootstrap'
import CustomCard from '../../../common/CustomCard'
import './style.sass'

const PartnerDashboard = () => {
    return (
        <div className="partner-dashboard-page-container">
            <Row>
                <Col>
                    <CustomCard>
                        <div class="card-component">
                            <div class="icon-container">
                                <i class="fa fa-exclamation-triangle icon-warn" />
                            </div>
                            <span class="card-subheading">
                                Oh, you are a bit early
                            </span>
                            <span class="card-description">
                                This site is coming to you some time in the future. But for now there is nothing for you here.
                            </span>
                        </div>
                    </CustomCard>

                </Col>
            </Row>
        </div>
    )
}

export default PartnerDashboard